import { hsIndexGeometry } from '../geometry-utils/index-geometry.function';
import type { HsIndexedGeometryData } from '../geometry-utils/indexed-geometry-data.class';
import { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';

/**
 * Handles s parse obj.
 */
export function hsParseOBJ(obj: string): HsIndexedGeometryData {
  const lines: string[] = obj.split('\r').join('').split('\t').join('').split('\n');
  const vertices: number[] = [];
  const normals: number[] = [];
  const uvs: number[] = [];
  const vertexIndices: number[] = [];
  const normalIndices: number[] = [];
  const uvIndices: number[] = [];
  for (const line of lines) {
    const tokens: string[] = line.trim().split(' ');
    if (tokens[0] === 'v') {
      vertices.push(parseFloat(tokens[1]));
      vertices.push(parseFloat(tokens[2]));
      vertices.push(parseFloat(tokens[3]));
    } else if (tokens[0] === 'vt') {
      uvs.push(parseFloat(tokens[1]));
      uvs.push(parseFloat(tokens[2]));
    } else if (tokens[0] === 'vn') {
      normals.push(parseFloat(tokens[1]));
      normals.push(parseFloat(tokens[2]));
      normals.push(parseFloat(tokens[3]));
    } else if (tokens[0] === 'f') {
      for (let i: number = 1; i < tokens.length; i++) {
        const indexTokens: string[] = tokens[i].split('/');
        vertexIndices.push(parseInt(indexTokens[0], 10) - 1);
        if (indexTokens.length > 1) {
          uvIndices.push(parseInt(indexTokens[1], 10) - 1);
        }
        if (indexTokens.length > 2) {
          normalIndices.push(parseInt(indexTokens[2], 10) - 1);
        }
      }
    }
  }
  const unindexedVertices: number[] = [];
  const unindexedNormals: number[] = [];
  for (let i: number = 0; i < vertexIndices.length; i++) {
    unindexedVertices.push(vertices[vertexIndices[i] * 3]);
    unindexedVertices.push(vertices[vertexIndices[i] * 3 + 1]);
    unindexedVertices.push(vertices[vertexIndices[i] * 3 + 2]);
  }
  for (let i: number = 0; i < normalIndices.length; i++) {
    unindexedNormals.push(normals[normalIndices[i] * 3]);
    unindexedNormals.push(normals[normalIndices[i] * 3 + 1]);
    unindexedNormals.push(normals[normalIndices[i] * 3 + 2]);
  }
  const data: HsRegularGeometryData = new HsRegularGeometryData(unindexedVertices, unindexedNormals);
  return hsIndexGeometry(data);
}
